import K_TabStrip from "../templates/K_TabStrip";
import { Component, ComponentOptions } from "./component";
import { TemplateComponent } from "./templateComponent";

export interface TabStripOptions extends ComponentOptions, kendo.ui.TabStripOptions {
    components?: Component[];
    tabs?: Tab[];
    animation?: any;
    height?: string;
    bsc?: string;
    style?: string;
}

export interface Tab {
    id?: string;
    label: string;
}

export class TabStrip extends TemplateComponent {

    options: TabStripOptions;
    content: {
        components: Component[];
    };

    constructor(options: TabStripOptions) {
        super(K_TabStrip, options);

        this.content = {
            components: options.components
        };
    }

    create() {
        var config: kendo.ui.TabStripOptions = {};
        if (this.options.animation !== undefined) {
            config.animation = this.options.animation;
        }

        $("#" + this.id).kendoTabStrip(config);
    }

}
